import Page from "./Page";
import { Link } from "inferno-router";
import "./Services.css";
import { DATACENTERS } from "./Datacenters";

export const SERVICES = "Services";

const blocks_per_year = 4855015;
const durations = [ blocks_per_year / 12, blocks_per_year / 4, blocks_per_year / 2, blocks_per_year ].map( blocks => Math.floor( blocks ).toLocaleString() );
const rebates = [ 0, 5, 10, 15, 25, 40, 60, 85 ].map( rebate => `${rebate}%` );
const rebateds = {
   // cosmoshub-4
   10150837 : "6CD463D02196A9075BF5A52A796D997EF802442E1C30D05FB33EF80D6E78883F",
   9746253 : "DC74946ECA3362A88D4AB4D343A44AC4AA9A6F8119B115A528D48E07FCEB63C7",
   9341669 : "B50A2DBD208D6FB27951F93BC5B87474D2FD9D4D6464A464A4BC464AE0144D97",
   8937085 : "D07C00F0B9DA6411216AB177DD978C702EFE1D6302B984821EF94F7F5F256DC6",
   8097015 : "A6889FDB6B5A81654731075329E08CDBFC3F7F0AA8DB821B47368F1624643AD9",
   7692431 : "4920772FE581D9C0F1967035355AD5C2685F7EA896F2D094D18D43505D90D84E",
   6881118 : "344929EDBD57AF0847C9E25DEF0FAC279133AEDED00CC638D29708B4FE216E75",
   6472090 : "A3B916285BC5D3B116682EBAA7F28E6A7B032004B197DC06016A343C0051BAA0",
   6060339 : "F092E9E91E06E5D375F47847DC1786EC9667711D43D51C78A7567BDD02CD4E0B",
   5244328 : "2092E3880303F5FFD657A2867B7861053DB57211510D86D1C3A300B7905B8DD1",
   5655755 : "26308B9E5C33B7E414ED0F3E34BBE3FEC4D378915EA7BAC5E0CE831EB22E1849",
   // cosmoshub-3
   4839744 : "94B5CD57B27ADB32B3F79860A76D9BBCCED37BA6CD3F6B0C5BD2DB7386E6D325",
   4436115 : "24B41D5F84479F2AECCD983AD2118143D08C6F35F5B2A08EE0497770372D7978",
   4034810 : "938FA966E20E6C807ED132EC313779A5DF640ED202382E3C90F27B1B72CA11F3",
   3632542 : "F190AA9B4ADC35C57B98FE47372D6AEC3437D8F14C05E0C85C9EBDB52B5B92DA",
   2816846 : "67EEE89CF6489DF59531F45D2FDB695C90DBE108BEB2ABE42556BCAEDD80446E",
   2816860 : "ECE8378431CDA88FFED6E46AA1A9EF14BDD1B98570B10B3A997D545EC858D148",
   2418298 : "4C9145C33B65759FB3D970332C4C473FFA9B7961F452CD3E9A1C4BBF313F5E06",
   2412313 : "8DCBAF635D02ACC70DAD5BB9632AF0FBA3AAB15C78EC1D612A100BA15D97E36A",
   2007889 : "D0101472B0BB0EBF5C997F3DAD134947A50A1D4F62163B1CCF02757E9892137E",
   2007900 : "55A7744979AD54A7C673F5B309CB9C9C147F6FE485279F487A8F632FC59745BF",
   1603191 : "31C7018989917F46B89DB878F93F0B7F414DADF7A62CD18D83CCD21E68CA9CD0",
   1603233 : "52E736E69BDF15C156819B2D1B0877FB99BCACA91BD15691EBC6E7FB121D17B0",
};


export default class Services extends Page {
   render() {
      return (
         <div className="Services">
            <h1><a id="StarnameValidator" href="#StarnameValidator"><img width="128" src="/logoIOV2.d25f8426.png" alt="Starname Validator"/> Validator</a></h1>

            <p>
               We are trusted by <a href="https://iov.one/" target="_blank">IOV</a> as proven
               by <a href="https://big-dipper.iov-mainnet-2.iov.one/transactions/0EFF15BCE957F50944515171CA6DB55195F5A4B0914F44229035C8836EB3A65F" target="_blank">their</a>
               &nbsp;<a href="https://big-dipper.iov-mainnet-2.iov.one/transactions/0D38D705618E6A717A3C38D688A6A51B78033A763B4A33C3AB8C35AE6CDECA8F" target="_blank">delegations</a>
               to our validator.
            </p>
            <p>
               Click to <a href="https://wallet.keplr.app/#/iov-mainnet/stake?modal=detail&validator=starvaloper1478t4fltj689nqu83vsmhz27quk7uggjtjp2gl" target="_blank">delegate</a>.
            </p>

            <h1><a id="CosmosValidator" href="#CosmosValidator"><img width="32" src="/cosmos-logo.4558870.png" alt="Cosmos Validator"/> Cosmos Validator</a></h1>

            <p>
               We are trusted by the <a href="https://interchain.io/" target="_blank">Interchain Foundation (ICF)</a> as proven by
               their <a href="https://stargazer.certus.one/validators/cosmosvaloper1rcp29q3hpd246n6qak7jluqep4v006cdsc2kkl" target="_blank">delegation</a> (cosmos1unc7...cstv)
               to our validator.
            </p>

            <p>
               Check out our <a href={`${SERVICES}#Rebates`}>rebates</a> or click to <a href="https://wallet.keplr.app/#/cosmoshub/stake?modal=detail&validator=cosmosvaloper1rcp29q3hpd246n6qak7jluqep4v006cdsc2kkl" target="_blank">delegate</a>.
            </p>
            <p>
               We run a Cosmos validator protected by dynamically allocated sentry nodes at our geographically distributed <Link to={`/${DATACENTERS}`}>datacenters</Link> in
               order to mitigate distributed denial of service (DDoS) attacks.
            </p>
            <p>
               Our validator, "<span className="emphasize">in3s.com</span>" (formerly "layover run"), was consistently in the top 5 of testnets over
               the past 8 months and ranked <a href="/FireShot Capture 20 - Cosmos - Game of Stakes Update 6_ - https___hubble.figment.network_chains_gos6.png" target="_blank">2nd</a> in
               the Game Of Stakes based on pre-commits. (If you don't trust our screenshot then visit <a href="https://web.archive.org/web/20190216201304/https://hubble.figment.network/chains/gos6" target="_blank">here</a> or
               <span> </span><a href="https://hubble.figment.network/chains/gos6" target="_blank">here</a> and sort by pre-commits - higher is better.)
            </p>
            <p>
               Our only missed blocks were due to a well-known and unstoppable censorship attack
               by <a href="/FireShot Capture 25 - The Big Dipper by Forbole_ - https___bigdipper.forbole.com_vali.png" target="_blank">validatorich</a> and
               forced gaiad restarts due to cosmos-sdk <a href="https://github.com/cosmos/cosmos-sdk/releases/tag/v0.31.2" target="_blank">breaking changes</a>.
               Our validator did not miss blocks <a href="FireShot Capture 22 - stargazer - https___stargazer.certus.one_blocks_7241.png" target="_blank">7241</a> or <a href="FireShot Capture 23 - stargazer - https___stargazer.certus.one_blocks_7242.png" target="_blank">7242</a> meaning
               that it withstood the massive tx spam attack and eagerly awaited the chain restart.
            </p>
            <p>
               We've contributed to the Cosmos community for over a year by
               filing bug <a href="https://github.com/tendermint/tendermint/issues/1169" target="_blank">reports</a>, (asking and) answering
               questions on <a href="https://matrix.to/#/@pooch:matrix.org" target="_blank">Riot</a>, and participating in many, many testnets.
            </p>
            <p>
               <a id="Rebates" href="#Rebates" style={{display:"hidden", border:"none", padding:0}}>in3s.com</a> was
               a Delaware corporation in <a href="https://icis.corp.delaware.gov/Ecorp/EntitySearch/NameSearch.aspx" target="_blank">good standing</a> (File
               Number 5460788).
            </p>
            <p>
               <span className="emphasize">Our validator exists purely to enhance the decentralization of Cosmos validators</span>.  We charge
               100% commission and all proceeds after expenses and <span className="emphasize underline">rebates</span> will be automatically delegated back to our validator.
               We are not liable for any damages.  Delegate to our validator at your own risk. <span className="emphasize">You will strengthen Cosmos and inherently add value
               to your atoms by delegating to our validator.</span>
            </p>

            <h2>Rebates</h2>

            <p>
               <table>
                  <tr>
                     <th><span className="Services-dt">months<span className="super emphasize">*</span>&nbsp;→</span> <span className="Services-atom">atoms&nbsp;↓</span></th><th>1</th><th>3</th><th>6</th><th>12+</th>
                  </tr>
                  <tr>
                     <td>&gt;  100,000</td><td data-rebate="1">{rebates[1]}</td><td data-rebate="2">{rebates[2]}</td><td data-rebate="3">{rebates[3]}</td><td data-rebate="4">{rebates[4]}</td>
                  </tr>
                  <tr>
                     <td>&gt;  500,000</td><td data-rebate="2">{rebates[2]}</td><td data-rebate="3">{rebates[3]}</td><td data-rebate="4">{rebates[4]}</td><td data-rebate="5">{rebates[5]}</td>
                  </tr>
                  <tr>
                     <td>&gt; 1,000,000</td><td data-rebate="3">{rebates[3]}</td><td data-rebate="4">{rebates[4]}</td><td data-rebate="5">{rebates[5]}</td><td data-rebate="6">{rebates[6]}</td>
                  </tr>
                  <tr>
                     <td>&gt; 5,000,000</td><td data-rebate="4">{rebates[4]}</td><td data-rebate="5">{rebates[5]}</td><td data-rebate="6">{rebates[6]}</td><td data-rebate="7">{rebates[7]}</td>
                  </tr>
                  <tr>
                     <th><span className="Services-atom">atoms&nbsp;↑</span> blocks&nbsp;→</th><th>{durations[0]}</th><th>{durations[1]}</th><th>{durations[2]}</th><th>{durations[3]}+</th>
                  </tr>
               </table>
               </p>
            <p>
               <span className="footnote"><span className="super emphasize">*</span>Months are an approximate measure of the duration of atom delegation;
               the exact measure is the genesis file's blocks_per_year divided by 12.</span>
            </p>
            <p>
               Rebates are based on the schedule above and the <span className="underline">total atoms</span> staked to our validator, so <span className="emphasize">you
               qualify for a rebate even if you delegate less than 100,000 atoms</span> as long as your delegation to our validator exists for at least {durations[0]} consecutive blocks
               and your portion of the total rebate exceeds 1 atom.
            </p>
            <p>
               Rebates are sent every {durations[0]} blocks (monthly<span className="super emphasize">*</span>) starting at block {Math.floor(blocks_per_year / 12 * 2).toLocaleString()},
               and are based on the "low water mark" for total staked atoms to our validator in the previous month.
            </p>
            <p>
               Rebates are not prorated on atoms or blocks (time).
            </p>
            <p>
               For example, if between 500k and 1M atoms are delegated to our validator for the entire month then <span className="emphasize">all of our delegators qualify</span> for
               the {rebates[3]} rebate.  If the total delegation to our validator is 700k atoms at the start of the month, 400k atoms are undelegated the day before month's end, and
               400k atoms are redelegated to our validator at month's end then <span className="emphasize">all of our delegators qualify</span> for the {rebates[2]} rebate.  That's
               because the low water mark for the month is 300k atoms even though the total delegation at the month's beginning and end is 700k.  Naturally, both scenarios require
               that your delegation to our validator exists for at least {durations[0]} consecutive blocks.
            </p>
            <p>
               Click to <a href="https://wallet.keplr.app/#/cosmoshub/stake?modal=detail&validator=cosmosvaloper1rcp29q3hpd246n6qak7jluqep4v006cdsc2kkl" target="_blank">delegate</a>.
            </p>
            <p>
               Every delegation to our validator helps keep Cosmos decentralized, which adds value to your atoms.  Know that you can delegate x% of your atoms to some other (small
               (less than 1M atoms staked) but <a href="https://blog.cosmos.network/game-of-stakes-closing-ceremonies-eddb71d3b114#147d" target="_blank">proven</a><span> </span>
               <a href="https://blog.cosmos.network/game-of-stakes-closing-ceremonies-eddb71d3b114#d1e2" target="_blank">good</a>) validator and y% to ours - you don't have
               to delegate to just a single validator.
            </p>

            <h2>Historical Rebates</h2>

            <div className="Services-rebated">
            {
               Object.keys( rebateds ).sort( ( a, b ) => b - a ).map( height => {
                  const tx = rebateds[height];
                  const href = height > 5200791 ? "https://www.mintscan.io/cosmos/txs" : "https://cosmoshub-3.bigdipper.live/transactions";

                  return <p><a target="_blank" href={`${href}/${tx}`}>{tx.substring( 0, 16 ) + "..." + tx.substring( 48 )}</a></p>
               } )
            }
            </div>

            { /*
            <h1><a id="DashMasternode" href="#DashMasternode"><img width="32" src="/dash.png" alt="Dash Masternode Co-Operative"/> Dash Masternode Co-Op</a></h1>

            <p className="Service-masternode">A Dash masternode yields <a href="http://178.254.23.111/~pub/Dash/ROI.html"
               target="_blank">7+%</a>, regardless of the price of Dash.  <a href="https://www.avaritia.com/dash/"
               target="_blank">Discover</a> why now is the time to get in on running a Dash masternode.
            </p>

            <h1>Monero Mining Pool</h1>

            <p>Pool selection with GeoDNS points your Monero miner to the closest of our regional <Link to={`/${DATACENTERS}`}>datacenters</Link>.</p>
            */ }

            <h1><a id="Consultancy" href="#Consultancy"><img width="48" src="/icon-128x128.png" alt="Consultancy"/> Consultancy</a></h1>

            <p>
               <div className="Service-skills">
                  <div className="Service-skill">
                     <fieldset className="Services-fieldset">
                        <legend>Algorithmic trading</legend>
                        <ul>
                           <li>Real-time strategies</li>
                           <li>Cryptocurrencies, bonds, stocks, foreign exchange (F/X), futures, options, futures options</li>
                        </ul>
                     </fieldset>
                  </div>
                  <div className="Service-skill">
                     <fieldset className="Services-fieldset">
                        <legend>Full-stack</legend>
                        <ul>
                           <li>C++, Java, JavaScript (Node), Node addons, Solidity</li>
                           <li>React, Redux, Vue, GWT, Inferno, Preact, WebPack, Truffle</li>
                           <li>DApps, Microservices, REST APIs</li>
                        </ul>
                     </fieldset>
                  </div>
                  <div className="Service-skill">
                     <fieldset className="Services-fieldset">
                        <legend>Automation</legend>
                        <ul>
                           <li>Graphical or headless operations (AWS Lambda)</li>
                        </ul>
                     </fieldset>
                  </div>
                  <div className="Service-skill">
                     <fieldset className="Services-fieldset">
                        <legend>Mobile apps</legend>
                        <ul>
                           <li>Android</li>
                           <li>iOS</li>
                        </ul>
                     </fieldset>
                  </div>
                  <div className="Service-skill">
                     <fieldset className="Services-fieldset">
                        <legend>Desktop apps</legend>
                        <ul>
                           <li>Linux</li>
                           <li>macOS</li>
                           <li>Windows</li>
                        </ul>
                     </fieldset>
                  </div>
               </div>
            </p>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/Services.js